import { Box, IconButton } from '@wix/design-system';
import { ChevronLeftLarge } from '@wix/wix-ui-icons-common';
import React, { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Page, useCurrentPage } from '../../../common/hooks/useCurrentPage';
import { appRoutes } from '../../../react-router';
import { backButtonDataHooks } from './BackButton.dataHooks';
import { useBackButtonBiTracker } from './useBackButtonBiTracker';

export const BackButton: FC = () => {
  const currentPage = useCurrentPage();
  const navigate = useNavigate();
  const logBackButton = useBackButtonBiTracker(currentPage);

  const goBack = useCallback(() => {
    logBackButton?.();
    navigate(appRoutes.home());
  }, [navigate, logBackButton]);

  if (currentPage === Page.Home) {
    // DO not show this Back Button on Homepage
    return null;
  }

  return (
    <Box margin="12px 0 0">
      <IconButton
        skin="transparent"
        priority="secondary"
        size="medium"
        onClick={goBack}
        dataHook={backButtonDataHooks.backButton()}
      >
        <ChevronLeftLarge />
      </IconButton>
    </Box>
  );
};
